<!-- 进场补录 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KNTYVWC",
          "carCode": "湘OQKKZA",
          "enterTime": "",
          "channelCode": "",
          "carCodeType": "",

          "carCodeColor": "",
          "enterCarType": "",
          "parkOrArea": ""
        },
        responseCode: {
          "data": {
            "carCode": "蒙A12345",
            "parkCode": "2KKN6112",
            "parkingCode": "220311170815185448325345",
            "recordCode": "220311170815261448325345"
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台补录进场记录",
          t_url: this.commonUrls.test + "supplementParkingRecordIn",
          p_url: this.commonUrls.prod + "supplementParkingRecordIn",
          precondition: "无",
          fitSystem: " 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号'
              },
              {
                info1: 'carCode',
                info2: '是',
                info3: 'String',
                info4: '车牌'
              },
              {
                info1: 'enterTime',
                info2: '是',
                info3: 'String',
                info4: '车辆进场时间(yyyyMMddHHmmss)'
              },
              {
                info1: 'channelCode',
                info2: '是',
                info3: 'String',
                info4: '通道自定义编码'
              },
              {
                info1: 'carCodeType',
                info2: '是',
                info3: 'Integer',
                info4: '进场车牌类型：0未定义,1蓝牌白字,2黄牌黑字,3黑牌白字,4白牌（默认1）'
              },
              {
                info1: 'carCodeColor',
                info2: '是',
                info3: 'Integer',
                info4: '车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色（默认为1）'
              },
              {
                info1: 'parkOrArea',
                info2: '是',
                info3: 'Integer',
                info4: '整场或区域：0 整场，1区域'
              },
              {
                info1: 'enterCarType',
                info2: '否',
                info3: 'Integer',
                info4: '车辆类型（0未知，1蓝牌车，2黄牌车"，3超大型车 4新能源小车，5新能源大车（vems：20 非机动车））默认1'
              },
              {
                info1: 'operatorName',
                info2: '否',
                info3: 'String',
                info4: '操作人名称'
              },
              {
                info1: 'operateTime',
                info2: '否',
                info3: 'String',
                info4: '操作时间(yyyyMMddHHmmss)'
              },
              {
                info1: 'recordType',
                info2: '是',
                info3: 'Integer',
                info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）默认1'
              },
              {
                info1: 'enterType',
                info2: '否',
                info3: 'String',
                info4: '进场类型：<url>参考附录:/Api/appendixData</url> (默认为7)'
              },
              {
                info1: 'reason',
                info2: '否',
                info3: 'String',
                info4: '进场原因'
              },
              {
                info1: 'selfInUserUniqCode',
                info2: '否',
                info3: 'String',
                info4: '进场用户标识'
              },

            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号'
              },
              {
                info1: 'carCode',
                info2: '是',
                info3: 'String',
                info4: '车牌号码'
              },
              {
                info1: 'parkingCode',
                info2: '是',
                info3: 'String',
                info4: '停车记录编号'
              },
              {
                info1: 'recordCode',
                info2: '是',
                info3: 'String',
                info4: '区域停车记录编号'
              },
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: [{
              info1: '000110',
              info2: '失败',
            }, {
              info1: '00110000',
              info2: '失败',
            }, {
              info1: '110000',
              info2: '失败',
            }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/supplementParkingRecordIn.vue